import React, {useContext} from "react"
import RefreshTimer from "../../util/RefreshTimer";
import {SblDeviceOverviewContext} from "./context/SblDeviceOverviewContext";
import Row from "@meridian/components/row";

const SblDeviceOverview = () => {
    const {viewModel} = useContext(SblDeviceOverviewContext);
    return (
            <Row widths={["grid-12"]} alignmentVertical="top" spacingInset="small">
                <RefreshTimer deps={[viewModel]}/>
            </Row>
    );
}

export default SblDeviceOverview



// WEBPACK FOOTER //
// ./src/components/devicemanagement/sbldevice/SblDeviceOverview.js